import { AppType, SignType } from "#/unique/domain";
import { Splash } from "@/Splash";
import { useStorage } from "^/common/useStorage";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/sign-up/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [type] = useStorage<AppType>("session-app-type");
  const [sns] = useStorage<SignType>("local-sign-sns-type");
  const { history } = useRouter();
  useEffect(() => {
    let url = `/sign-up/customer?sns-type=${sns}`;
    if (type === "business") {
      url = `/login-stage?sns-type=${sns}`;
    }
    history.push(url);
  }, [type, sns, history]);
  return <Splash visible />;
}
